module.exports = __webpack_public_path__ + "sx11-ff4d7738.png";